<template>
  <b-modal
    ref="modal"
    lazy
    id="replace-report-modal"
    @hide="$emit('hide', $event)"
  >
    <template slot="modal-title">
      <h5 class="modal-title">
        {{ "Review.View.Messages.10" | localized }}
      </h5>
    </template>
    <template slot="modal-footer">
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        @click="handleCancel"
      >
        {{ "Review.View.Report.6" | localized }}
      </button>
      <button type="button" class="btn btn-sm btn-primary" @click="handleOK">
        {{ "Review.View.Messages.12" | localized }}
      </button>
    </template>
    <!-- content -->
    <div>{{ "Review.View.Messages.11" | localized }}</div>
  </b-modal>
</template>

<script>
export default {
  name: "ReportModalUpload",
  methods: {
    show() {
      this.$refs.modal.show();
    },
    handleCancel() {
      this.$refs.modal.hide("cancel");
    },
    handleOK() {
      this.$refs.modal.hide("ok");
    },
  },
};
</script>

<style scoped></style>
